import { component } from 'picoapp';

const CURRENT_ITEM_CLASS = 'label-animated__item--current';
const NEXT_ITEM_CLASS = 'label-animated__item--next';
const TEXT_IN_CLASS = 'label-animated__moving-row--in';

const TEXT_IN_MS = 300;
const HOLD_MS = 2000;
const TEXT_OUT_MS = 300;

const getCurrentItem = (items) =>
  items.find((item) => item.classList.contains(CURRENT_ITEM_CLASS)) || items[0];

const normalizeItems = (items) => {
  items.forEach((item, index) => {
    if (!item.classList.contains(CURRENT_ITEM_CLASS) && !item.classList.contains(NEXT_ITEM_CLASS)) {
      item.classList.add(index === 0 ? CURRENT_ITEM_CLASS : NEXT_ITEM_CLASS);
    }
  });
};

const setActiveItemAccessibility = (items, currentItem) => {
  items.forEach((item) => {
    const isCurrent = item === currentItem;
    item.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
    item.toggleAttribute('inert', !isCurrent);
  });
};

const setTextIn = (item, isIn) => {
  const movingRow = item.querySelector('.label-animated__moving-row');
  if (!movingRow) {
    return;
  }
  movingRow.classList.toggle(TEXT_IN_CLASS, isIn);
};

export default component((node) => {
  const items = Array.from(node.querySelectorAll('[data-label-animated-item]'));
  let rotationTimeoutId;
  let cycleTimeoutId;
  let animationFrameId;

  if (items.length <= 1) {
    return;
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  normalizeItems(items);
  const initialItem = getCurrentItem(items);
  setTextIn(initialItem, true);
  setActiveItemAccessibility(items, initialItem);

  const runCycle = () => {
    const currentItem = getCurrentItem(items);
    const currentIndex = items.indexOf(currentItem);
    const nextItem = items[currentIndex + 1] || items[0];

    setTextIn(currentItem, false);

    rotationTimeoutId = window.setTimeout(() => {
      currentItem.classList.remove(CURRENT_ITEM_CLASS);
      currentItem.classList.add(NEXT_ITEM_CLASS);
      nextItem.classList.remove(NEXT_ITEM_CLASS);
      nextItem.classList.add(CURRENT_ITEM_CLASS);

      setActiveItemAccessibility(items, nextItem);

      // Ensure the "next" item is in the starting position before animating in.
      setTextIn(nextItem, false);
      animationFrameId = window.requestAnimationFrame(() => {
        setTextIn(nextItem, true);

        rotationTimeoutId = window.setTimeout(() => {
          cycleTimeoutId = window.setTimeout(runCycle, HOLD_MS);
        }, TEXT_IN_MS);
      });
    }, TEXT_OUT_MS);
  };

  cycleTimeoutId = window.setTimeout(runCycle, HOLD_MS);

  return () => {
    window.clearTimeout(cycleTimeoutId);
    if (rotationTimeoutId) {
      window.clearTimeout(rotationTimeoutId);
    }
    if (animationFrameId) {
      window.cancelAnimationFrame(animationFrameId);
    }
  };
});
